// End of April 12 in Ulaanbaatar time (UTC+08:00).
const APRIL_12_END_MN_TS = Date.parse("2026-04-12T23:59:59+08:00")

export function isBeforePromoEnd(
  endDate: Date | string | number = APRIL_12_END_MN_TS
): boolean {
  const endTimestamp =
    endDate instanceof Date ? endDate.getTime() : new Date(endDate).getTime()
  return (
    Date.now() <=
    (Number.isNaN(endTimestamp) ? APRIL_12_END_MN_TS : endTimestamp)
  )
}

export function isAfterPromoStart(startDate: Date | string | number): boolean {
  const startTimestamp =
    startDate instanceof Date
      ? startDate.getTime()
      : new Date(startDate).getTime()
  return Date.now() >= (Number.isNaN(startTimestamp) ? 0 : startTimestamp)
}
